import React, { useState } from 'react';
import cn from 'classnames';
import { Script } from 'gatsby';
import { Title, Icon, Loader } from '@landing/ui';
import { Container, Button } from 'components/UI';
import { useInView } from 'react-intersection-observer';
import { socialButtons } from 'define/locale';

import * as styles from './SocialMedia.module.scss';

export default function SocialMedia({ title, theme }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const [loaded, setLoaded] = useState(false);

  return (
    <Container
      className={cn(styles.mainContainer, theme && styles[theme])}
      background="transparent"
      padding="Horizontal"
    >
      <div className={styles.layout}>
        <Title className={styles.title} tag="h2">
          {title}
        </Title>
      </div>
      <div className={styles.instaWrapper} ref={inViewRef}>
        {inView && (
          <>
            {!loaded && <Loader theme="fullHeight" />}
            <div className={'elfsight-app-36116494-d230-4c39-8e25-a97a1aef80cb'}></div>
            <Script
              src="https://apps.elfsight.com/p/platform.js"
              strategy="idle"
              onLoad={() => setLoaded(true)}
            />
          </>
        )}
      </div>
      <div className={styles.layout}>
        <div className={styles.buttonRow}>
          {socialButtons.map(({ name, icon, link }) => (
            <Button
              key={name}
              tag="a"
              href={link}
              className={styles.button}
              theme="transparentBg"
              textColor="white"
              fullWidthMobile
            >
              <span className={styles.buttonContent}>
                {icon && <Icon name={icon} className={styles.icon} />}
                {name}
              </span>
            </Button>
          ))}
        </div>
      </div>
    </Container>
  );
}
